import { faArrowToBottom } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'components/button/Button';
import styled from 'styled-components';
import { link } from 'styles/theme';
import { fetchFileFromApi } from 'utils/fetch';
import { downloadFile, FileType } from 'utils/file';

const DownloadButton = styled(Button)`
    color: ${link};
`;

export type JobFileDownloadButtonProps = Readonly<{
    id: string;
    fileName: string;
    isErrorFile: boolean;
}>;

export function JobFileDownloadButton({
    id,
    fileName,
    isErrorFile,
}: JobFileDownloadButtonProps) {
    const onDownloadClick = async () => {
        const file = await fetchFileFromApi(
            `jobs/${id}/${isErrorFile ? 'errorFile' : 'uploadedFile'}`,
            fileName,
            FileType.Excel,
            {
                method: 'GET',
            }
        );
        downloadFile(file);
    };

    return (
        <DownloadButton onClick={() => onDownloadClick()}>
            {isErrorFile ? (
                <FontAwesomeIcon icon={faArrowToBottom} className="f-18" />
            ) : (
                fileName
            )}
        </DownloadButton>
    );
}
